import { render, staticRenderFns } from "./EndMatch.vue?vue&type=template&id=2dab2b3d&scoped=true"
import script from "./EndMatch.vue?vue&type=script&lang=js"
export * from "./EndMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dab2b3d",
  null
  
)

export default component.exports